export class FormError extends Error {
  constructor(fieldErrors, message = 'Form validation errors') {
    super(message)
    this.name = 'FormError'
    this.fieldErrors = fieldErrors
  }
}
